module.exports = __webpack_public_path__ + "static/media/maarten-van-den-heuvel-gZXx8lKAb7Y-unsplash.18773450.jpg";